/**
 * Shared toast / notification timing constants. Centralized so the
 * cross-feature dismiss cadence stays consistent (and so a future
 * change to "how long does a transient toast hang around" is one
 * edit, not a grep + replace across every saga that dispatches an
 * addNotification).
 */

// Default auto-dismiss for transient user-action toasts (e.g.
// "Moved to tomorrow", "Marked blocked"). Long enough to read +
// undo, short enough not to clutter the stack.
export const TOAST_AUTO_DISMISS_MS = 5000;
